import { Component, ElementRef, HostListener, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ServiceService } from '../service.service';
import { ToastRef, ToastrService } from 'ngx-toastr';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatDialog } from '@angular/material/dialog';
import { Width } from 'ngx-owl-carousel-o/lib/services/carousel.service';
import { UserService } from 'src/app/views/pages/auth/UserDetails/user.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Notification } from '../../../core/Notifications/Notification';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-logincart',
  templateUrl: './logincart.component.html',
  styleUrls: ['./logincart.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class LogincartComponent implements OnInit {
  [x: string]: any;

  
  form: FormGroup;
  selectedName: any = [];
  totalcharge: any = 0;
  doctorid: any;
  dialogRef: any;
  selectedOption: any;
  resultPayData: any;
  hos_id:any;
  transaction_id:any;
  @ViewChild(NgSelectComponent) ngSelectComponent: NgSelectComponent;
  

  constructor(private router: Router, private fb: FormBuilder, private notif: Notification, private service: ServiceService, private toastr: ToastrService, private user: UserService, public dialog: MatDialog) {
    this.form = this.fb.group({
      consult_Type: new FormControl(0),
      appt_DO_Id_FK: new FormControl(),
      symptoms: new FormControl()
    
    })

  }

  userData: any;
  ngOnInit(): void {
    this.user_name=localStorage.getItem('phoneNumber');
    this.hos_id = sessionStorage.getItem('hos_id')
    this.getAllComplaints();
    this.getClinicalDoctor();

    this.service.Get_Userprofile( this.hos_id).subscribe((res: any) => {
      this.userData = res;
      console.log("Login name", this.userData.firstName)
    })
    this.paymentQuickUrl = environment.pay_quick_url;
  }

  onClear() {
    // Handle clearing the selected item
    this.totalcharge = 0;
    this.doctorid = null;
    this.selectedName = [];
    console.log("totalcharge", this.totalcharge)
    console.log("Doctor Id", this.doctorid)

  }
  isOptionDisabled(option: any): boolean {
    const selectedOptions = this.form.value.symptoms;
    if (!selectedOptions || selectedOptions.length === 0) {
      return false;
    }
    const noneOptionSelectedd = selectedOptions && selectedOptions.some((item: any) => item.cmst_Name === "Other than Listed(ಪಟ್ಟಿ ಮಾಡಲಾದ ಹೊರತುಪಡಿಸಿ)");
    if (noneOptionSelectedd) {
      return option.cmst_Name != "Other than Listed(ಪಟ್ಟಿ ಮಾಡಲಾದ ಹೊರತುಪಡಿಸಿ)" && noneOptionSelectedd;
    }
    else {
      return option.cmst_Name == "Other than Listed(ಪಟ್ಟಿ ಮಾಡಲಾದ ಹೊರತುಪಡಿಸಿ)"
    }


  }
  price() {
    console.log("test value", this.form.value.name1)
  }
  data: any;
  getClinicalDoctor() {
    this.service.clinicalDoctor().subscribe((res: any) => {
      this.data = res;
      console.log("clical doctor", this.data)
    })
  }

  complaints_data: any;
  getAllComplaints() {
    this.service.Get_Complaintsdd().subscribe((res: any) => {
      this.complaints_data = res;
      // console.log("clical doctor", this.data)
    })
  }

  result: any
  // submit() {
  //   var appData = {
  //     "appt_DO_Id_FK": this.doctorid,
  //     "complaint": this.form.value.symptoms,      
  //     "charges": this.totalcharge,
  //     "req_quick_consult":'Yes'

  //   }  
  //   if (!this.form.value.symptoms || this.form.value.symptoms.length === 0) {
  //     this.notif.errorsmsg('Please select complaints before proceeding to payment.');
  //     return;
  //   }
  //   console.log('appt data : ' + JSON.stringify(appData))
  //   this.service.InsertAppointment_consultnow(appData).subscribe((data: any) => {
  //     this.result = data
  //     console.log("payment url: " + this.result.value);
  //     this.openPayLink(this.result.value)
  //   })
  // }

  submit(): void {
    var appData = {
      do_id: this.doctorid,
      complaint: this.form.value.symptoms, 
      user_name:this.user_name ,    
      // charges: this.totalcharge,
      // req_quick_consult:'Yes'
      payment_from: "PORTAL QUICK CONSULT"

    }
    if (!this.form.value.symptoms || this.form.value.symptoms.length === 0) {
           this.notif.errorsmsg('Please select complaints before proceeding to payment.');
           return;
         }
    console.log("quick url :" +JSON.stringify(appData));
    this.service.ProcessRequestOrderQuick(appData).subscribe(
      (res) => {
        console.log('Complete Response:', res); // Inspect the full response here
        
        if (res) {
          // Try accessing transaction_id
          this.resultPayData = res;
          
          console.log('Transaction ID:', this.resultPayData.transaction_id);
          if (this.resultPayData.transaction_id) {
            console.log('Transaction ID exists:', this.resultPayData.transaction_id);
            this.transaction_id='QUICK'+this.resultPayData.transaction_id;
             this.router.navigate(['/base/patient/payment-form/' + this.transaction_id]);
           
          } else {
            console.log('Transaction ID is undefined or null');
          }
        } else {
          console.log('Response is undefined or null');
        }
      },
      (error) => {
        console.error('Error:', error);
      }
    );
    

    // const url = this.constructPaymentUrl(appData);
    // window.open(url, "_blank");
  }
  
  // constructPaymentUrl(appData: any): string {
  //   console.log("landing url :" +this.paymentQuickUrl);
  //   const baseUrl = this.paymentQuickUrl;
  //   debugger
  //   const queryParams = new URLSearchParams({
  //     complaint: JSON.stringify(appData.complaint),
  //     do_id: appData.appt_DO_Id_FK,
  //     user_name: this.user_name,
  //     payment_from: "PORTAL"
  //   });

  //   return `${baseUrl}?${queryParams.toString()}`;
  // }

  openPayLink(url: string) {
    window.open(url, "_blank");
  }

  doctorCharge() {
    this.totalcharge = this.selectedName.charges;
    this.doctorid = this.selectedName.dO_Id_FK;
    console.log("totalcharge", this.totalcharge)
    console.log("Doctor Id", this.doctorid)
  }

  onDelete(event: any) {
    this.totalcharge = 0;
    this.doctorid = null;
    this.selectedName = [];
    console.log("totalcharge", this.totalcharge)
    console.log("Doctor Id", this.doctorid)
    event.preventDefault();


  }

  onEnter(event: any) {
    this.totalcharge = this.selectedName.charges;
    this.doctorid = this.selectedName.dO_Id_FK;
    console.log("totalcharge", this.totalcharge)
    console.log("Doctor Id", this.doctorid)
    // You can also prevent the default Enter key behavior if needed
    event.preventDefault();
  }
  
  
}
 
